import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { useFireRenderedSpinner } from '../../hooks/useProfileCardAnalytics';

import { CardPopupWrapper } from './CardPopupWrapper';

const styles = cssMap({
	inner: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
	fill: {
		flex: '1',
		minWidth: '0px',
	},
	row: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
		borderBottom: `${token('border.width')} solid ${token('color.border.disabled')}`,
	},
});

function SkeletonRow() {
	return (
		<Inline space="space.150" alignBlock="center" xcss={styles.row}>
			<Skeleton width="48px" height="48px" borderRadius={token('radius.full')} />
			<Stack space="space.100" xcss={styles.fill}>
				<Skeleton width="40%" height="12px" borderRadius={token('radius.small')} />
				<Skeleton width="70%" height="12px" borderRadius={token('radius.small')} />
			</Stack>
		</Inline>
	);
}

// Loading state. Fires `rendered.spinner` on mount so the event only emits
// when the spinner is actually on screen.
export function CardLoading({ testId }: { testId?: string }): React.JSX.Element {
	useFireRenderedSpinner();
	return (
		<CardPopupWrapper>
			<Box testId={testId} role="status">
				<Stack space="space.100" xcss={styles.inner}>
					<Inline space="space.200" alignBlock="center">
						<Skeleton width="72px" height="72px" borderRadius={token('radius.full')} />
						<Stack space="space.100" xcss={styles.fill}>
							<Skeleton width="35%" height="12px" borderRadius={token('radius.small')} />
							<Skeleton width="65%" height="12px" borderRadius={token('radius.small')} />
						</Stack>
					</Inline>
					<SkeletonRow />
					<SkeletonRow />
				</Stack>
			</Box>
		</CardPopupWrapper>
	);
}
